<template>
  <div
    class="crop-area flex absolute inset-0 overflow-y-auto"
    style="z-index: 500; max-width:100%; max-height:100%;"
  >
    <!-- 画像 -->
    <div
      class="inline-block"
      style="height:85%; width:80%; margin-top:auto; margin-bottom:auto; margin:auto;"
    >
      <img id="cropper-img" :src="source" />
      <!-- メニューボタン -->
      <button
        class="block absolute zoomer-button text-white ml-1 mr-1 mt-1"
        style="height:35px; width:90px; top:0; right:0;"
        type="button"
        @click="closeImgZoomer"
      >
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useImgUploader } from '@/services/useImgUploader'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'AppImageZoomer',

  components: {},
  props: {
    source: String,
  },
  setup() {
    let zoomObj = ref([])
    let { closeImgZoomer } = useImgUploader()
    onMounted(() => {
      zoomObj.value = []
      const cropperImg = document.getElementById('cropper-img')
      const cropper = new Cropper(cropperImg)
      zoomObj.value = cropper
      // 以下cropperオブジェクトの各種設定変更
      // Cropperの表示モードの設定。1は切り取り枠が画像外に出ない(初期値:0 制限なし)
      zoomObj.value.options.viewMode = 1
      // ウインドウサイズ変更時にトリミングされた領域を復元するかどうかを設定。(trueだと挙動がおかしいのでfalseにする)
      zoomObj.value.options.restore = false
      // マウスホイールのズーム速度を変更(初期値:0.1)
      zoomObj.value.options.wheelZoomRatio = 0.15
      // トリミングボックス外の切り抜き画像をドラッグした時の動作を設定。(初期は'crop')
      zoomObj.value.options.dragMode = 'move'
      // 画像とトリミングボックスの間に黒い半透明のレイヤーを挟むかどうかを設定。
      zoomObj.value.options.modal = false
      // トリミングボックスの中央にインジケーターを表示するかどうかを設定。
      zoomObj.value.options.center = false
      // トリミングボックスの上に白い半透明のレイヤーを重ねるかどうかを設定。
      zoomObj.value.options.highlight = false
      // トリミングボックスの上には線を表示するかどうかを設定。
      zoomObj.value.options.guides = false
      // ドラッグでトリミングボックスを移動できるようにするかを設定。
      zoomObj.value.options.cropBoxMovable = false
      // ドラッグでトリミングボックスをリサイズできるようにするかを設定。
      zoomObj.value.options.cropBoxResizable = false
      // コンテナをダブルクリックした時に、ドラッグモードを”crop”と”move”で切り替えるかどうかを設定。
      zoomObj.value.options.toggleDragModeOnDblclick = false
    })
    return {
      zoomObj,
      closeImgZoomer,
    }
  },
}
</script>

<style lang="scss">
.cropper-view-box {
  outline: none;
}
.cropper-border {
  border: solid 2px #fff;
}
.cropper-header-border {
  border: solid 2px #fff;
  border-bottom: none;
}
.zoomer-button {
  text-decoration: none;
  background: #549a1d50;
  border: double 4px #ffffff50;
  border-radius: 3px;
  transition: 0.4s;
}
.zoomer-button:hover {
  background: #549a1d;
  border: double 4px #ffffff;
}
</style>
